import Candace from '@backrs_ui/common-ui/src/assets/images/login/candace.png';
import Marcus from '@backrs_ui/common-ui/src/assets/images/login/marcus.png';
import Rosie from '@backrs_ui/common-ui/src/assets/images/login/rosie.png';
import Shake from '@backrs_ui/common-ui/src/assets/images/login/shake.png';
import { Carousel, CarouselItem } from '@backrs_ui/common-ui/src/atoms/Carousel';

import { Box, Typography, SxProps, Theme } from '@mui/material';

const items: CarouselItem[] = [
  {
    imageUrl: Marcus,
    name: 'Marcus',
    description: 'Marcus landed an internship at TFA',
  },
  {
    imageUrl: Rosie,
    name: 'Rosie',
    description: 'Rosie got a scholarship to Vanderbilt',
  },
  {
    imageUrl: Candace,
    name: 'Candace',
    description: 'Candace interned with HCA',
  },
  {
    imageUrl: Shake,
    name: 'Shake',
    description: 'Shake got a full ride to Wash U',
  },
];

type LoginCarouselItemProps = Readonly<{
  item: CarouselItem;
  isActive: boolean;
}>;

const LoginCarouselItem = ({ item, isActive }: LoginCarouselItemProps) => {
  return (
    <Box sx={carouselItemSx}>
      <Box component="img" sx={imageSx(isActive)} src={item.imageUrl} alt={item.name} />

      <Typography
        variant="display-sm-semibold"
        color={(theme) => theme.backrs.colors['Colors/Base/Black']}
        sx={descriptionSx(isActive)}
      >
        {item.description}
      </Typography>
    </Box>
  );
};

export const LoginCarousel = () => {
  return (
    <Carousel
      items={items}
      autoTransitionInterval={5000}
      renderItem={(item, isActive) => <LoginCarouselItem item={item} isActive={isActive} />}
    />
  );
};

const descriptionSx =
  (isActive: boolean): SxProps<Theme> =>
  ({ backrs }) => ({
    opacity: isActive ? 1 : 0,
    transition: 'opacity 0.3s ease-in-out',
    px: backrs.spacing['spacing-xl'],
    textAlign: 'center',
    position: 'relative',
    zIndex: 2,
    pb: '5%',
  });

const carouselItemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: {
    md: backrs.spacing['spacing-xl'],
    lg: backrs.spacing['spacing-2xl'],
    xl: backrs.spacing['spacing-3xl'],
  },
  marginTop: {
    md: `-${backrs.spacing['spacing-4xl']}`,
    lg: `-${backrs.spacing['spacing-5xl']}`,
  },
  height: '100%',
  position: 'relative',
  pb: {
    md: backrs.spacing['spacing-6xl'],
    lg: backrs.spacing['spacing-7xl'],
  },
});

const imageSx =
  (isActive: boolean): SxProps<Theme> =>
  ({ backrs }) => ({
    opacity: isActive ? 1 : 0,
    transition: 'opacity 0.3s ease-in-out',
    height: 'auto',
    width: {
      md: '70%',
      lg: '75%',
      xl: '85%',
    },
    justifyContent: 'center',
    margin: '0 auto',
    justifySelf: 'center',
    padding: 0,
    mt: {
      md: backrs.spacing['spacing-2xl'],
      lg: backrs.spacing['spacing-4xl'],
      xl: backrs.spacing['spacing-6xl'],
    },
  });
